<template>
  <div>
    <div class="cui-example cui-example-vertical-spacing">
      <b-card :header="`${$t('reports')} / ${$t('report_requests')}`" header-tag="h6" class="mb-4">
        <div class="row">
          <div class="col-12 mb-1">
            <span class="pull-left">{{ $t('files_will_delete_after_a_week') }}</span>
            <b-btn
              class="pull-right"
              size="sm"
              variant="success"
              @click="getReportRequests"
            >
              <i class="fas fa-sync"></i> {{ $t('refresh') }}
            </b-btn>
          </div>

          <div class="col-12">
            <vue-good-table
              ref="GoodTable"
              styleClass="vgt-table striped"
              :mode="'remote'"
              compactMode
              row-style-class="table-text"
              :max-height="'500'"
              :columns="columns"
              :rows="tableData"
              :totalRows="totalRecords"
              :isLoading.sync="isTableLoading"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :sort-options="{
                enabled: true
              }"
              :pagination-options="{
                enabled: true,
                mode: 'pages',
                // Per Page
                perPage: 10,
                perPageDropdown: [5, 10, 30, 50],
                dropdownAllowAll: false,
                // Translation
                nextLabel: $t('next'),
                prevLabel: $t('prev'),
                rowsPerPageLabel: $t('rows_per_page'),
                ofLabel: $t('of'),
                pageLabel: $t('page'), // for 'pages' mode
                allLabel: $t('all'),
              }"
            >
              <div slot="loadingContent">
                <span class="badge badge-info p-2">{{ $t('loading') }}</span>
              </div>

              <div class="text-center" slot="emptystate">
                {{ $t("no_records_found") }}
              </div>

              <template slot="table-column" slot-scope="props">
                <span class="table-text">
                  {{ props.column.label }}
                </span>
              </template>

              <template slot="table-row" slot-scope="props">
                <span class="table-text" v-if="props.column.field === 'status'">
                  <span :class="statusColors[props.row.status.toString()]" class="p-2">{{ props.row.status_display }}</span>
                </span>
                <span class="table-text" v-else-if="props.column.field === 'file'">
                  <a
                    v-if="props.row.status === 2 && props.row.file !== null"
                    :href="props.row.file"
                    class="btn btn-sm btn-success"
                    target="_blank"
                    download
                  >
                    <i class="fas fa-download mr-1"></i> {{ $t('download') }}
                  </a>
                  <b-btn
                    v-else-if="props.row.status === 3"
                    size="sm"
                    variant="primary" 
                    @click="createReportAgain(props.row.id)"
                  >
                    <i class="fas fa-history mr-1"></i> {{ $t('create_report_again') }}
                  </b-btn>
                  <!-- <b-btn :class="statusColors[props.formattedRow['status']]">{{ props.formattedRow['status_display'] }}</span> -->
                </span>
                <span class="table-text" v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <div slot="table-actions-bottom" class="footer-bg">
                <span class="ml-2" v-if="totalRecords > 0">
                  {{ 'Toplam Kayıt Sayısı : ' + totalRecords }}
                </span>
              </div>
            </vue-good-table>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Api from '@/services/Api'
import customLoading from '@/components/widgets/customLoading'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import report from '../../store/modules/report'

export default {
  name: 'report_requests',
  metaInfo () {
    let title = this.$t('report_requests')
    return {
      title: title,
    }
  },
  components: {
    customLoading,
    VueGoodTable
  },
  data () {
    return {
      isTableLoading: false,
      totalRecords: 0,
      interval: null,
      columns: [
        {
          label: this.$t('report'),
          field: 'report',
          sortable: false
        },
        {
          label: this.$t('status'),
          field: 'status',
          sortable: false
        },
        {
          label: this.$t('file_format'),
          field: 'file_format',
          sortable: false
        },
        {
          label: this.$t('created_at'),
          field: 'created_at',
        },
        {
          label: this.$t('completed_at'),
          field: 'completed_at',
        },
        {
          label: this.$t('file'),
          field: 'file',
          sortable: false
        },
      ],
      tableData: [],
      statusColors: {
        '0': 'badge badge-secondary',
        '1': 'badge badge-warning',
        '2': 'badge badge-success',
        '3': 'badge badge-danger'
      },
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        limit: 10
      },
    }
  },
  methods: {
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
    },
    onPerPageChange (params) {
      this.updateParams({ limit: params.currentPerPage })
    },
    onSortChange (params) {
      this.updateParams({ sort: params })
    },
    onColumnFilter (params) {
      this.updateParams(params)
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
      this.getReportRequests()
    },

    controlReportRequests () {
      const uncopmletedReports = this.tableData.filter(v => v.status === 0 || v.status === 1)

      if (uncopmletedReports.length > 0) {
        if (this.interval === null) {
          this.interval = setInterval(this.getReportRequests, 5000)
        }
      } else {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    getReportRequests () {
      this.isTableLoading = true
      const self = this
      Api.post(this, 'ats/report-request/list', this.serverParams)
        .then(response => {
          if (response.status) {
            this.tableData = response.data
            this.totalRecords = response.count
            this.controlReportRequests()
          } else {
            this.$swal.fire({
              title: this.$t('swal_process_failed'),
              text: this.$t('swal_failed_to_fetch_report_requests'),
              type: 'warning',
              button: this.$t('ok')
            })
          }
        })
        .catch(e => {
          console.log(`e`, e)
          self.$swal.fire({
            title: self.$t('swal_process_failed'),
            text: self.$t('swal_process_failed'),
            type: 'error',
            button: self.$t('ok'),
          })
        })
      self.isTableLoading = false
    },
    createReportAgain (request_id) {
      Api.put(this, 'ats/report-request/update', { request_id: request_id })
        .then(response => {
          if (response.status) {
            this.$swal.fire({
              title: this.$t('swal_process_success'),
              text: this.$t('swal_process_success'),
              type: 'success',
              button: this.$t('ok')
            })
            this.getReportRequests()
          } else {
            this.$swal.fire({
              title: this.$t('swal_process_failed'),
              text: this.$t('swal_process_failed'),
              type: 'warning',
              button: this.$t('ok')
            })
          }
        })
        .catch(e => {
          console.log(`e`, e)
          self.$swal.fire({
            title: self.$t('swal_process_failed'),
            text: self.$t('swal_process_failed'),
            type: 'error',
            button: self.$t('ok'),
          })
        })
    }
  },
  created () {
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  mounted () {
    this.getReportRequests()
  }
}
</script>

<style>
  .footer-bg {
    background-color: white;
  }
  .table-text {
    font-size: 12px !important;
  }
  .vgt-wrap__footer {
    font-size: 12px !important;
    justify-content: center;
  }
  .vgt-wrap__footer .footer__row-count {
    font-size: 12px !important;
    justify-content: center;
  }
  .vgt-wrap__footer .footer__navigation {
    font-size: 12px !important;
    justify-content: center;
  }
  .vgt-wrap__footer .footer__row-count__select {
    font-size: 12px !important;
  }
  .vgt-wrap__footer .footer__row-count__label {
    font-size: 12px !important;
  }
  .vgt-wrap__footer .footer__navigation__page-btn > span{
    font-size: 12px !important;
  }
</style>
